module.exports = __webpack_public_path__ + "media/components/brandings/svgs/email/branding-email-bg-4fd67be2afa2f183172cb74671ef078a.svg";